// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Text from "../Text.bs.js";
import * as Util from "../../../../common/util.bs.js";
import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as Caml_obj from "@rescript/std/lib/es6/caml_obj.js";
import * as StaticImage from "../../../StaticImage.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var wrapper = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.white),
      tl: {
        hd: BsCss.backgroundImage(BsCss.url("/images/about/shoutAboutBg.svg")),
        tl: {
          hd: BsCss.backgroundRepeat("noRepeat"),
          tl: {
            hd: BsCss.backgroundPosition("center"),
            tl: {
              hd: BsCss.backgroundSize("cover"),
              tl: {
                hd: BsCss.height(BsCss.pct(100.0)),
                tl: {
                  hd: BsCss.width(BsCss.pct(100.0)),
                  tl: {
                    hd: BsCss.position("relative"),
                    tl: {
                      hd: BsCss.paddingTop(BsCss.px(20)),
                      tl: {
                        hd: BsCss.paddingBottom(BsCss.px(20)),
                        tl: {
                          hd: BsCss.margin("auto"),
                          tl: {
                            hd: BsCss.media("(min-width: 768px)", {
                                  hd: BsCss.height(BsCss.px(750)),
                                  tl: /* [] */0
                                }),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var innerWrapper = Curry._1(BsCss.style, {
      hd: BsCss.bottom(BsCss.px(46)),
      tl: {
        hd: BsCss.left(BsCss.px(0)),
        tl: {
          hd: BsCss.right(BsCss.px(0)),
          tl: {
            hd: BsCss.margin("auto"),
            tl: {
              hd: BsCss.media("(max-width: 480px)", {
                    hd: BsCss.width(BsCss.pct(90.0)),
                    tl: /* [] */0
                  }),
              tl: {
                hd: BsCss.media("(min-width: 480px) and (max-width: 640px)", {
                      hd: BsCss.width(BsCss.pct(70.0)),
                      tl: /* [] */0
                    }),
                tl: {
                  hd: BsCss.media("(min-width: 640px) and (max-width: 767px)", {
                        hd: BsCss.width(BsCss.pct(55.0)),
                        tl: /* [] */0
                      }),
                  tl: {
                    hd: BsCss.media("(min-width: 768px)", {
                          hd: BsCss.display("flex"),
                          tl: {
                            hd: BsCss.flexDirection("row"),
                            tl: {
                              hd: BsCss.justifyContent("center"),
                              tl: {
                                hd: BsCss.position("absolute"),
                                tl: /* [] */0
                              }
                            }
                          }
                        }),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var awardContainer = Curry._1(BsCss.style, {
      hd: BsCss.marginRight(BsCss.px(25)),
      tl: {
        hd: BsCss.media("(min-width: 1440px)", {
              hd: BsCss.width(BsCss.px(370)),
              tl: {
                hd: BsCss.marginTop(BsCss.px(-180)),
                tl: /* [] */0
              }
            }),
        tl: {
          hd: BsCss.media("(min-width: 1280px)", {
                hd: BsCss.width(BsCss.px(340)),
                tl: {
                  hd: BsCss.marginTop(BsCss.px(-180)),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: BsCss.media("(min-width: 1024px)", {
                  hd: BsCss.width(BsCss.px(308)),
                  tl: {
                    hd: BsCss.marginTop(BsCss.px(-180)),
                    tl: /* [] */0
                  }
                }),
            tl: {
              hd: BsCss.media("(min-width: 768px)", {
                    hd: BsCss.width(BsCss.px(344)),
                    tl: {
                      hd: BsCss.marginTop(BsCss.px(-180)),
                      tl: /* [] */0
                    }
                  }),
              tl: {
                hd: BsCss.media("(max-width: 767px)", {
                      hd: BsCss.marginRight(BsCss.px(0)),
                      tl: {
                        hd: BsCss.margin("auto"),
                        tl: {
                          hd: BsCss.marginBottom(BsCss.px(19)),
                          tl: /* [] */0
                        }
                      }
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var titleText = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(40)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(50)),
        tl: {
          hd: BsCss.paddingBottom(BsCss.px(30)),
          tl: {
            hd: BsCss.color(Theme.Color.white),
            tl: {
              hd: BsCss.fontWeight("semiBold"),
              tl: {
                hd: BsCss.fontStyle("normal"),
                tl: {
                  hd: BsCss.media("(max-width: 767px)", {
                        hd: BsCss.fontSize(BsCss.px(32)),
                        tl: {
                          hd: BsCss.lineHeight(BsCss.px(42)),
                          tl: {
                            hd: BsCss.paddingBottom(BsCss.px(20)),
                            tl: {
                              hd: BsCss.paddingTop(BsCss.px(20)),
                              tl: /* [] */0
                            }
                          }
                        }
                      }),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var imgContainer = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.white),
      tl: {
        hd: BsCss.borderRadius(BsCss.px(10)),
        tl: {
          hd: BsCss.height(BsCss.px(450)),
          tl: {
            hd: BsCss.media("(min-width: 1440px)", {
                  hd: BsCss.width(BsCss.px(370)),
                  tl: /* [] */0
                }),
            tl: {
              hd: BsCss.media("(min-width: 1280px)", {
                    hd: BsCss.width(BsCss.px(340)),
                    tl: /* [] */0
                  }),
              tl: {
                hd: BsCss.media("(min-width: 1024px)", {
                      hd: BsCss.width(BsCss.px(308)),
                      tl: /* [] */0
                    }),
                tl: {
                  hd: BsCss.media("(min-width: 768px)", {
                        hd: BsCss.width(BsCss.px(344)),
                        tl: /* [] */0
                      }),
                  tl: {
                    hd: BsCss.media("(max-width: 767px)", {
                          hd: BsCss.margin("auto"),
                          tl: {
                            hd: BsCss.height(BsCss.pct(100.0)),
                            tl: {
                              hd: BsCss.paddingBottom(BsCss.px(15)),
                              tl: /* [] */0
                            }
                          }
                        }),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var innerContainer = Curry._1(BsCss.style, {
      hd: BsCss.marginLeft(BsCss.px(18)),
      tl: {
        hd: BsCss.marginRight(BsCss.px(18)),
        tl: {
          hd: BsCss.marginBottom(BsCss.px(18)),
          tl: /* [] */0
        }
      }
    });

var awardsImgContainer = Curry._1(BsCss.style, {
      hd: BsCss.display("flex"),
      tl: {
        hd: BsCss.justifyContent("spaceBetween"),
        tl: {
          hd: BsCss.alignItems("center"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(15)),
            tl: /* [] */0
          }
        }
      }
    });

var img = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.pct(30.0)),
      tl: /* [] */0
    });

var awardsSubTitleText = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(16)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(64)),
        tl: {
          hd: BsCss.color(Theme.Color.prezzeeRed),
          tl: {
            hd: BsCss.fontWeight("normal"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: {
                hd: BsCss.media("(max-width: 480px)", {
                      hd: BsCss.lineHeight(BsCss.px(25)),
                      tl: {
                        hd: BsCss.paddingTop(BsCss.px(30)),
                        tl: /* [] */0
                      }
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var mediaSubTitleText = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(16)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(64)),
        tl: {
          hd: BsCss.color(Theme.Color.prezzeeRed),
          tl: {
            hd: BsCss.fontWeight("normal"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: {
                hd: BsCss.marginBottom(BsCss.px(25)),
                tl: {
                  hd: BsCss.media("(max-width: 480px)", {
                        hd: BsCss.lineHeight(BsCss.px(25)),
                        tl: {
                          hd: BsCss.paddingTop(BsCss.px(20)),
                          tl: /* [] */0
                        }
                      }),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var mediaLogo1 = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(96)),
      tl: {
        hd: BsCss.height(BsCss.px(22)),
        tl: {
          hd: BsCss.margin("auto"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(33)),
            tl: /* [] */0
          }
        }
      }
    });

var mediaLogo2 = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(173)),
      tl: {
        hd: BsCss.height(BsCss.px(22)),
        tl: {
          hd: BsCss.margin("auto"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(33)),
            tl: /* [] */0
          }
        }
      }
    });

var mediaLogo3 = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(96)),
      tl: {
        hd: BsCss.height(BsCss.px(22)),
        tl: {
          hd: BsCss.margin("auto"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(33)),
            tl: /* [] */0
          }
        }
      }
    });

var mediaLogo4 = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(135)),
      tl: {
        hd: BsCss.height(BsCss.px(22)),
        tl: {
          hd: BsCss.margin("auto"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(33)),
            tl: /* [] */0
          }
        }
      }
    });

var mediaLogo5 = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(136)),
      tl: {
        hd: BsCss.height(BsCss.px(22)),
        tl: {
          hd: BsCss.margin("auto"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(33)),
            tl: /* [] */0
          }
        }
      }
    });

var mediaLogo6 = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(96)),
      tl: {
        hd: BsCss.height(BsCss.px(22)),
        tl: {
          hd: BsCss.margin("auto"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(33)),
            tl: /* [] */0
          }
        }
      }
    });

var mediaLogo7 = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(201)),
      tl: {
        hd: BsCss.height(BsCss.px(22)),
        tl: {
          hd: BsCss.margin("auto"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(33)),
            tl: /* [] */0
          }
        }
      }
    });

var Styles = {
  wrapper: wrapper,
  innerWrapper: innerWrapper,
  awardContainer: awardContainer,
  titleText: titleText,
  imgContainer: imgContainer,
  innerContainer: innerContainer,
  awardsImgContainer: awardsImgContainer,
  img: img,
  awardsSubTitleText: awardsSubTitleText,
  mediaSubTitleText: mediaSubTitleText,
  mediaLogo1: mediaLogo1,
  mediaLogo2: mediaLogo2,
  mediaLogo3: mediaLogo3,
  mediaLogo4: mediaLogo4,
  mediaLogo5: mediaLogo5,
  mediaLogo6: mediaLogo6,
  mediaLogo7: mediaLogo7
};

function MediaSection(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("h2", {
                                    children: [
                                      "We've got ",
                                      JsxRuntime.jsx("u", {
                                            children: "a lot"
                                          }),
                                      " to shout about"
                                    ],
                                    className: titleText
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx($$Text.make, {
                                                  children: "We're award winning...",
                                                  className: awardsSubTitleText
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/1.png",
                                                          alt: "fast starters award",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        }),
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/2.png",
                                                          alt: "fast 50 award",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        }),
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/3.png",
                                                          alt: "fast 500 award",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        })
                                                  ],
                                                  className: awardsImgContainer
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/4.png",
                                                          alt: "woman in finance award",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        }),
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/5.png",
                                                          alt: "retailer award 2018",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        }),
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/6.png",
                                                          alt: "retailer award 2017",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        })
                                                  ],
                                                  className: awardsImgContainer
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/7.png",
                                                          alt: "iAwards national merit",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        }),
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/8.png",
                                                          alt: "iAwards nsw winner",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        }),
                                                    JsxRuntime.jsx(StaticImage.make, {
                                                          src: "/images/about/awards/9.png",
                                                          alt: "iAwards national winner",
                                                          width: 199,
                                                          height: 199,
                                                          className: img
                                                        })
                                                  ],
                                                  className: awardsImgContainer
                                                })
                                          ],
                                          className: innerContainer
                                        }),
                                    className: imgContainer
                                  })
                            ],
                            className: awardContainer
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx($$Text.make, {
                                          children: "We've been featured in...",
                                          className: mediaSubTitleText
                                        }),
                                    Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                          TAG: /* Ok */0,
                                          _0: /* UnitedStates */2
                                        }) ? JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(StaticImage.make, {
                                                  src: "/images/about/media/forbes_logo.png",
                                                  alt: "forbes logo",
                                                  width: 170,
                                                  height: 44
                                                }),
                                            className: mediaLogo1
                                          }) : null,
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(StaticImage.make, {
                                                src: "/images/about/media/afr_logo.png",
                                                alt: "afr logo",
                                                width: 520,
                                                height: 66
                                              }),
                                          className: mediaLogo2
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(StaticImage.make, {
                                                src: "/images/about/media/retailbiz.png",
                                                alt: "retailbiz logo",
                                                width: 288,
                                                height: 66
                                              }),
                                          className: mediaLogo3
                                        }),
                                    Caml_obj.equal(Util.EnvUtil.currentCountry, {
                                          TAG: /* Ok */0,
                                          _0: /* Australia */0
                                        }) ? JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(StaticImage.make, {
                                                  src: "/images/about/media/herald_sun.png",
                                                  alt: "herald sun logo",
                                                  width: 405,
                                                  height: 66
                                                }),
                                            className: mediaLogo4
                                          }) : null,
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(StaticImage.make, {
                                                src: "/images/about/media/the_telegraph_logo.png",
                                                alt: "the telegraph logo",
                                                width: 408,
                                                height: 66
                                              }),
                                          className: mediaLogo5
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(StaticImage.make, {
                                                src: "/images/about/media/sky_news_logo.png",
                                                alt: "sky news logo",
                                                width: 290,
                                                height: 66
                                              }),
                                          className: mediaLogo6
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(StaticImage.make, {
                                                src: "/images/about/media/sydney_morning_herald_logo.png",
                                                alt: "sydney morning herald logo",
                                                width: 605,
                                                height: 66
                                              }),
                                          className: mediaLogo7
                                        })
                                  ],
                                  className: innerContainer
                                }),
                            className: imgContainer
                          })
                    ],
                    className: innerWrapper
                  }),
              className: wrapper
            });
}

var Img;

var make = MediaSection;

export {
  Img ,
  Styles ,
  make ,
}
/* wrapper Not a pure module */
